module.exports = __webpack_public_path__ + "media/sora_resolution_1080p.422a5b37.mp4";